import type { SVGAttributes } from "react";

export default function AppLogoIcon(props: SVGAttributes<SVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 36 36"
      fill="none"
      {...props}
    >
      <defs>
        <linearGradient id="compralytics-grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#0055FF" />
          <stop offset="100%" stopColor="#00AAFF" />
        </linearGradient>
      </defs>

      <rect x="0" y="0" width="36" height="36" rx="10" fill="url(#compralytics-grad)" />
      <circle 
        cx="18" 
        cy="18" 
        r="11" 
        stroke="white" 
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeDasharray="52 18"
        strokeDashoffset="8"
        fill="none"
      />
      <circle 
        cx="18" 
        cy="18" 
        r="5.5" 
        fill="white"
      />
    </svg>
  );
}
